export default __webpack_public_path__ + "static/Nail6-f76793ed5079c250271c514a48a699e1.png";